import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../css/common/Maintenance.css';

function MaintenanceNotice() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/', { replace: true });
    }, 3000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="maintenance-shell">
      <div className="maintenance-card">
        <h1>メンテナンス中です。</h1>
      </div>
    </div>
  );
}

export default MaintenanceNotice;
